(function () {
    angular.module('app')
        .component('wistiaEmbed', {
            bindings: {
                videoId: '@',
                fullScreen: '<?',
                loop: '<?',
                autoPlay: '<?',
                mute: '<?',
                timeout: '<?',
                onReady: '&?',
                onError: '&?'
            },
            template: `
                <div ng-style="$ctrl.wrapperDimensions">
                    <div class="wrapper" ng-style="$ctrl.wrapperOffset">
                        <div class="wistia_embed wistia_async_{{$ctrl.videoId}}"></div>
                    </div>
                </div>
                <div class="overlay" ng-hide="!$ctrl.fullScreen" ng-click="$ctrl.togglePlay()">
                    <div class="controls">
                        <div class="volume" ng-if="!$ctrl.mute" ng-click="$ctrl.toggleMute($event)">
                            <img ng-hide="!$ctrl.muted" src="/images/volumeMuted.svg" />
                            <img ng-hide="$ctrl.muted" src="/images/volumeUnMuted.svg" />
                        </div>

                        <div class="fast-forward" ng-class="{active: $ctrl.rewinding}" ng-click="$ctrl.toggleRewind($event)">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23 14.3" enable-background="new 0 0 23 14.3" xml:space="preserve" class="wistia_vulcan_svg_icon wistia_vulcan_svg_icon_play wistia_vulcan_svg_icon_play_small">
                            <polygon points="10,0 10,14.3 0,7.5 "></polygon>
                            <polygon points="23,0 23,14.3 13,7.5 "></polygon>
                            </svg>
                        </div>
                        <div class="state">
                            <img ng-hide="$ctrl.$playing" src="/images/play.svg" />
                            <img ng-hide="!$ctrl.$playing" src="/images/pause.svg" />
                        </div>
                        <div class="fast-forward" ng-class="{active: $ctrl.fastForwarding}" ng-click="$ctrl.toggleFastForward($event)">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23 14.3" enable-background="new 0 0 23 14.3" xml:space="preserve" class="wistia_vulcan_svg_icon wistia_vulcan_svg_icon_play wistia_vulcan_svg_icon_play_small">
                            <polygon points="0,0 0,14.3 10,7.5 "></polygon>
                            <polygon points="13,0 13,14.3 23,7.5 "></polygon>
                            </svg>
                        </div>
                    </div>
                </div>
            `,
            controller: wistiaEmbedController
        });
    var id = 1;
    wistiaEmbedController.$inject = ['$element', '$window', '$timeout', '$interval'];
    function wistiaEmbedController($element, $window, $timeout, $interval) {
        var ctrl = this;
        ctrl.$onInit = function () {
            ctrl.$embedId = id;
            id++;
            ctrl.$options = {
                wmode: 'transparent',
                controlsVisibleOnLoad: !!ctrl.fullscreen
            };
            if (!ctrl.timeout) {
                ctrl.timeout = 30;
            }
            if (ctrl.mute === undefined) {
                ctrl.mute = true;
            }
        }
        ctrl.$onChanges = function (changes) {
            if (changes.videoId.currentValue) {
                if (ctrl.$video) {
                    ctrl.ready = false;
                    ctrl.$video.replaceWith(changes.videoId.currentValue, ctrl.$options);
                }
                else {
                    ctrl.$initVideo();
                }
            }
            else if (ctrl.$video) {
                ctrl.$video.pause();
            }
        }
        ctrl.$postLink = function () {
            $timeout(function () {
                if (ctrl.fullScreen) {
                    $element.addClass('full-screen');
                }
                ctrl.$window = angular.element($window);
                ctrl.$playing = ctrl.autoPlay;
                if (ctrl.autoPlay) {
                    ctrl.$options.autoPlay = true;
                    ctrl.$window.on('focus.wistiaEmbed' + ctrl.$embedId, function () {
                        if (ctrl.$video && ctrl.$playing) {
                            $timeout(function () {
                                ctrl.$video.play();
                            });
                        }
                    });
                }
                if ($element.hasClass('full-screen')) {
                    ctrl.$window.on('resize.wistiaEmbed' + ctrl.$embedId, function () {
                        $timeout.cancel(ctrl.$resizeDelay);
                        ctrl.$resizeDelay = $timeout(ctrl.$$sizeVideo, 300);
                    });
                    ctrl.$wrapper = $element.find('.wrapper');
                    ctrl.$$sizeVideo();
                }
                if (ctrl.videoId) {
                    ctrl.$timeoutTimer = $timeout(function () {
                        if (ctrl.onError) {
                            ctrl.onError({
                                message: 'Video timed out.'
                            });
                        }
                    }, ctrl.timeout * 1000);
                }
            })
        }

        ctrl.$onDestroy = function () {
            ctrl.$window.off('resize.wistiaEmbed' + ctrl.$embedId).off('focus.wistiaEmbed' + ctrl.$embedId);
        }

        ctrl.$initVideo = function () {
            ctrl.ready = false;
            $window._wq = $window._wq || [];
            _wq.push({
                id: ctrl.videoId,
                options: ctrl.$options,
                onReady: function (video) {
                    $timeout.cancel(ctrl.$timeoutTimer);
                    ctrl.$video = video;
                    ctrl.$video.volume(ctrl.mute ? 0 : 1);
                    if (ctrl.loop) {
                        ctrl.$video.bind('end', function () {
                            ctrl.$video.time(0);
                            ctrl.$video.play();
                        }).bind('play', function () {
                            $timeout(function () {
                                ctrl.$playing = true;
                            });
                        }).bind('pause', function () {
                            $timeout(function () {
                                ctrl.$playing = false;
                            });
                        });
                    }
                    if (ctrl.autoPlay) {
                        ctrl.$video.play();
                    }
                    $timeout(function () {
                        ctrl.ready = true;
                        if (ctrl.onReady) {
                            ctrl.onReady({
                                video: video
                            });
                        }
                    })
                },
            })
        }

        ctrl.togglePlay = function () {
            if (ctrl.ready) {
                $interval.cancel(ctrl.$rewinder);
                ctrl.$video.playbackRate(1);
                if (!ctrl.$playing) {
                    ctrl.$video.play();
                }
                else {
                    ctrl.$video.pause();
                    ctrl.fastForwarding = false;
                    ctrl.rewinding = false;
                }
            }
        }

        ctrl.toggleMute = function ($event) {
            if (ctrl.ready) {
                ctrl.muted = !ctrl.muted;
                ctrl.$video.volume(ctrl.muted ? 0 : 1);
            }
            $event.stopPropagation();
        }

        ctrl.toggleRewind = function ($event) {
            if (ctrl.ready) {
                ctrl.fastForwarding = false;
                ctrl.rewinding = !ctrl.rewinding;
                ctrl.$video.playbackRate(1);
                if (ctrl.rewinding) {
                    ctrl.$video.pause();
                    ctrl.$lastTime = new Date().getTime();
                    ctrl.$rewinder = $interval(function () {
                        var curTime = new Date().getTime();
                        var change = (curTime - ctrl.$lastTime) / 500;
                        var time = Math.max(ctrl.$video.time() - change, 0);
                        if (time === 0) {
                            $interval.cancel(ctrl.$rewinder);
                            ctrl.$video.play();
                        }
                        else {
                            ctrl.$video.time(time);
                            ctrl.$lastTime = curTime;
                            ctrl.rewinding = false;
                        }
                    }, 100);
                }
                else {
                    $interval.cancel(ctrl.$rewinder);
                    ctrl.$video.play();
                }
            }
            $event.stopPropagation();
        };

        ctrl.toggleFastForward = function ($event) {
            if (ctrl.ready) {
                $interval.cancel(ctrl.$rewinder);
                ctrl.rewinding = false;
                ctrl.fastForwarding = !ctrl.fastForwarding;
                ctrl.$video.playbackRate(ctrl.fastForwarding ? 2 : 1);
                ctrl.$video.play();
            }
            $event.stopPropagation();
        }

        ctrl.$$sizeVideo = function () {
            var optimalHeight = $element.width() / 16 * 9;
            var height = ctrl.$wrapper.innerHeight();
            if (optimalHeight < $element.height()) {
                var wrapperWidth = $element.height() / height * $element.width();
                ctrl.wrapperDimensions = {
                    width: wrapperWidth,
                    left: -((wrapperWidth - $element.width()) / 2)
                };
                if (ctrl.$video) {
                    $timeout(function () {
                        ctrl.$video.videoWidth(wrapperWidth, { constrain: true });
                    })
                }
            }
            else {
                ctrl.wrapperDimensions = undefined;
            }
            if ($element.height() < height) {
                ctrl.wrapperOffset = {
                    top: ($element.height() - height) / 2
                }
            }
            else {
                ctrl.wrapperOffset = undefined;
            }
        }
    }
})();